{{#if pages}}
    {{#checkLength pages 1}}
    <div class="blocks blocks_2up blocks_alignOuter">
        <div><button class="link link_back js-action--carouselPrev">prev</button></div>
        <div><button class="link link_carrot js-action--carouselNext">next</button></div>
    </div>
    {{ else }}
    {{/checkLength}}
<div class="carousel carousel_viewFiles">
    <div class="js-element--carousel">
    {{#each pages}}
        <div class="carousel-slide isDelayed isDelayed_med">
            <img src="{{largeUrl}}" alt="">
        </div>
    {{/each}}
    </div>
</div>
{{/if}}
